(function () {
    function qs(sel, p) { return (p || document).querySelector(sel); }
    function qsa(sel, p) { return Array.prototype.slice.call((p || document).querySelectorAll(sel)); }

    // Small inline spinner (mirrors statistics.js look&feel)
    function getLoadingSVGHTML() {
        return '<span class="h-8 w-8">' +
            '<svg class="h-full w-full" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" stroke="#2d3748">' +
            '  <g fill="none" fill-rule="evenodd" stroke-width="4">' +
            '    <circle cx="22" cy="22" r="1">' +
            '      <animate values="1; 20" attributeName="r" begin="0s" dur="1.8s" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate>' +
            '      <animate values="1; 0" attributeName="stroke-opacity" begin="0s" dur="1.8s" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate>' +
            '    </circle>' +
            '    <circle cx="22" cy="22" r="1">' +
            '      <animate values="1; 20" attributeName="r" begin="-0.9s" dur="1.8s" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate>' +
            '      <animate values="1; 0" attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate>' +
            '    </circle>' +
            '  </g>' +
            '</svg>' +
            '</span>';
    }

    // AJAX load table ("Vis")
    function fetchResults(e) {
        if (e) e.preventDefault();
        var form = qs('#sysinfo-all-form');
        if (!form) return;

        var params = new URLSearchParams(new FormData(form)); // flat inputs
        var headers = {};
        var endpoint = form.getAttribute('data-endpoint') || (qs('#dealer_id', form) ? '/action/sys-info' : '/action/sys-info-dealer');

        var dealerIdInput = qs('#dealer_id', form);
        if (dealerIdInput && dealerIdInput.value) {
            headers['X-Dealer-Id'] = dealerIdInput.value;
            params.delete('dealer_id');
        }

        var url = endpoint + '?' + params.toString();

        fetch(url, { method: 'GET', headers: headers, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (json) {
                if (json && json.html !== undefined) {
                    qs('#sysinfo-all-report-wrapper').innerHTML = json.html;
                    initSorting('sysinfo-all-table');
                } else if (json && json.errors) {
                    qs('#sysinfo-all-report-wrapper').innerHTML = '<div class="alert alert-danger"><strong>' + escapeHtml(json.errors) + '</strong></div>';
                }
            })
            .catch(function (err) {
                qs('#sysinfo-all-report-wrapper').innerHTML = '<div class="alert alert-danger"><strong>Uventet feil.</strong></div>';
                console.error(err);
            });
    }

    function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
            return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'})[c];
        });
    }

    // ----- Sorting (unchanged) -----
    function initSorting(tableId) {
        var table = qs('#' + tableId);
        if (!table) return;

        var headers = qsa('thead th', table);
        headers.forEach(function (th, idx) {
            th.addEventListener('click', function () {
                var type = th.getAttribute('data-sort-type') || 'str';
                var current = th.getAttribute('data-sort-dir') || 'none';
                var dir = (current === 'asc') ? 'desc' : 'asc';

                headers.forEach(function (h) { h.setAttribute('data-sort-dir','none'); });
                th.setAttribute('data-sort-dir', dir);

                sortTable(table, idx, type, dir === 'asc');
            });
        });
    }

    function cellValue(td) {
        return td ? td.textContent.trim() : '';
    }

    function sortTable(table, colIndex, type, asc) {
        var tbody = table.tBodies[0];
        var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr'));

        var cmp;
        if (type === 'num') {
            cmp = function (a, b) {
                var A = parseFloat(cellValue(a.children[colIndex]).replace(/[^0-9.\-]/g,'')) || 0;
                var B = parseFloat(cellValue(b.children[colIndex]).replace(/[^0-9.\-]/g,'')) || 0;
                return A === B ? 0 : (A < B ? -1 : 1);
            };
        } else {
            cmp = function (a, b) {
                var A = cellValue(a.children[colIndex]).toLowerCase();
                var B = cellValue(b.children[colIndex]).toLowerCase();
                return A.localeCompare(B);
            };
        }

        rows.sort(function (r1, r2) { return asc ? cmp(r1, r2) : -cmp(r1, r2); });

        var frag = document.createDocumentFragment();
        rows.forEach(function (r) { frag.appendChild(r); });
        tbody.appendChild(frag);
    }

    // ----- Excel export (new) -----

    // Build the { title, headers, rows } that ExcelExportService expects
    function extractSysInfoTable() {
        var table = qs('#sysinfo-all-table');
        if (!table) return null;

        var headers = [];
        var headerRow = table.querySelector('thead tr');
        if (headerRow) {
            qsa('th', headerRow).forEach(function (th) {
                headers.push(th.textContent.trim());
            });
        }

        var rows = [];
        qsa('tbody tr', table).forEach(function (tr) {
            var row = [];
            qsa('td', tr).forEach(function (td) {
                row.push(td.textContent.trim());
            });
            if (row.length) rows.push(row);
        });

        // Title from the export button data attribute (set in the PHP view)
        var exportBtn = qs('#sysinfo-all-export-button');
        var title = (exportBtn && exportBtn.getAttribute('data-report-title')) || 'SysInfo – Alle lisenser';

        return { title: title, headers: headers, rows: rows };
    }

    // Map filter labels → values so they render nicely in the Excel header
    function collectFiltersDisplay() {
        var form = qs('#sysinfo-all-form');
        if (!form) return {};

        var map = {};
        // Pair <label for="..."> with the matching input’s current value
        qsa('label[for]', form).forEach(function (label) {
            var forId = label.getAttribute('for');
            if (!forId) return;
            var input = qs('#' + forId, form);
            if (!input) return;

            var labelText = (label.textContent || '').trim().replace(/:$/, '');
            var val = '';
            if (input.tagName === 'SELECT') {
                // For selects, prefer the selected option's label text, but only if a non-empty value is chosen
                if (input.value && input.selectedIndex >= 0 && input.options[input.selectedIndex]) {
                    val = (input.options[input.selectedIndex].text || '').trim();
                } else {
                    val = '';
                }
            } else {
                val = (input.value || '').trim();
            }

            if (val) {
                map[labelText] = val;
            }
        });

        return map;
    }

    function initiateExcelExportSysInfo() {
        var exportBtn = qs('#sysinfo-all-export-button');
        if (!exportBtn) return;

        // Guard: require a rendered table
        var table = qs('#sysinfo-all-table');
        if (!table) {
            alert('Ingen data å eksportere. Klikk "Vis" for å hente rapporten først.');
            return;
        }

        var originalHTML = exportBtn.innerHTML;
        exportBtn.innerHTML = getLoadingSVGHTML();
        exportBtn.disabled = true;

        // Build payload similar to statistics.js -> initiateExcelExport()
        var now = new Date();
        var ymd = now.toISOString().slice(0, 10);

        var reportType  = exportBtn.getAttribute('data-report-type')  || 'sysinfo_all';
        var reportTitle = exportBtn.getAttribute('data-report-title') || 'SysInfo – Alle lisenser';

        var tableData = extractSysInfoTable();
        var payload = {
            report_type: reportType,
            report_title: reportTitle,
            start_date: ymd,       // SysInfo is not date-bound; set to today for header consistency
            end_date: ymd,
            filters_display: collectFiltersDisplay(),
            sort_column: null,
            sort_direction: null,
            chart_images: {},      // no charts on this view
            tables: tableData ? [tableData] : []
        };

        fetch('/action/statistics/export-excel', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            credentials: 'same-origin',
            body: JSON.stringify(payload)
        })
            .then(function (response) {
                if (!response.ok) throw new Error('Excel generation failed');
                return response.blob();
            })
            .then(function (blob) {
                exportBtn.innerHTML = originalHTML;
                exportBtn.disabled = false;

                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;

                // Nice filename; server may also set Content-Disposition
                var pad = function (n) { return (n < 10 ? '0' : '') + n; };
                var ts = now.getFullYear() + '' + pad(now.getMonth() + 1) + '' + pad(now.getDate()) +
                    '-' + pad(now.getHours()) + '' + pad(now.getMinutes());
                a.download = reportType + '-' + ts + '.xlsx';

                document.body.appendChild(a);
                a.click();
                a.remove();

                setTimeout(function () { window.URL.revokeObjectURL(url); }, 0);
            })
            .catch(function (err) {
                exportBtn.innerHTML = originalHTML;
                exportBtn.disabled = false;
                console.error('Error exporting Excel:', err);
                alert('En feil oppstod under generering av Excel.');
            });
    }

    // ----- Wire up -----
    document.addEventListener('DOMContentLoaded', function () {
        var form = qs('#sysinfo-all-form');
        if (form) form.addEventListener('submit', fetchResults);

        var exportBtn = qs('#sysinfo-all-export-button');
        if (exportBtn) {
            exportBtn.addEventListener('click', function (e) {
                e.preventDefault();
                initiateExcelExportSysInfo();
            });
        }
    });
})();
